import { DataBean } from "../DataBean";

export class UpdateProdcutionOrderIn extends DataBean {



    public async updateProductionOrderInProgressData(year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateProductionOrderInProgressData_Number", [year]);
    }
    
}